import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#333] border-t-[#FF6A00]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/inloggen" state={{ from: location.pathname }} replace />;
  }
  return children;
}
